import { Button, Input } from "@heroui/react";
import { useState } from "react";
import { BigProfileCreation } from "@/api/businessProfiles";

interface LocationFormProps {
  defaults?: Partial<BigProfileCreation>;
  onSubmit: (data: Partial<BigProfileCreation>) => void;
}

export function LocationForm({ defaults, onSubmit }: LocationFormProps) {
  const [formData, setFormData] = useState({
    location_display_name: defaults?.location_display_name || "",
    location_total_area: defaults?.location_total_area || 0,
    address: defaults?.address || "",
    city: defaults?.city || "",
    metro_station: defaults?.metro_station || "",
    district: defaults?.district || "",
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <div className="w-full">
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <Input
          label="Название локации"
          placeholder="Введите название локации"
          value={formData.location_display_name}
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              location_display_name: e.target.value,
            }))
          }
          isRequired
          variant="bordered"
        />
        <Input
          label="Общая площадь"
          placeholder="Введите общую площадь"
          value={formData.location_total_area.toString()}
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              location_total_area: parseInt(e.target.value),
            }))
          }
          isRequired
          variant="bordered"
        />
        <Input
          label="Адрес"
          placeholder="Введите полный адрес"
          value={formData.address}
          onChange={(e) =>
            setFormData((prev) => ({ ...prev, address: e.target.value }))
          }
          isRequired
          variant="bordered"
        />
        <Input
          label="Город"
          placeholder="Введите город"
          value={formData.city}
          onChange={(e) =>
            setFormData((prev) => ({ ...prev, city: e.target.value }))
          }
          isRequired
          variant="bordered"
        />
        <div className="flex flex-col lg:flex-row gap-4">
          <Input
            label="Станция метро"
            placeholder="Введите станцию метро"
            value={formData.metro_station}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                metro_station: e.target.value,
              }))
            }
            variant="bordered"
            className="flex-1"
          />
          <Input
            label="Район"
            placeholder="Введите район"
            value={formData.district}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, district: e.target.value }))
            }
            variant="bordered"
            className="flex-1"
          />
        </div>
        <div className="flex flex-row gap-2 justify-end">
          <Button
            type="submit"
            className="bg-elastic-500 hover:bg-elastic-600 text-black font-medium">
            Далее
          </Button>
        </div>
      </form>
    </div>
  );
}
